import React from 'react';
import { isElectron } from '../../helpers/EnvironmentFlags/EnvironmentFlags';
import { ContinueSavedSessionWeb } from './ContinueSavedSessionWeb';
import { ContinueSavedSessionKiosk } from './ContinueSavedSessionKiosk';

export const ContinueSavedSession = React.memo(() => (isElectron() ? <ContinueSavedSessionKiosk /> : <ContinueSavedSessionWeb />));
